export default {
  lang: {
    selectAll: 'เลือกหน้าปัจจุบันทั้งหมด',
    selected: 'เลือกแล้ว',
    term: 'แถบ',
    deselect: 'ยกเลิกการเลือก',
  },
};
